namespace GeniuzPOS.AdvPromo {
    export enum LoopPmTypeFg {
        LoopPmType0 = 0,
        LoopPmType1 = 1
    }
    Serenity.Decorators.registerEnumType(LoopPmTypeFg, 'GeniuzPOS.AdvPromo.LoopPmTypeFg');
}
